import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

export const buildCalendarDays = (dates, selectedMonth) => {
  dayjs.extend(isoWeek);
  dayjs.extend(isSameOrBefore);
  const datesAsString = dates.join(',');

  const firstDayOfMonth = dayjs(selectedMonth).startOf('month');
  const lastDayOfMonth = dayjs(selectedMonth).endOf('month');
  let currentDayOfPage = firstDayOfMonth.startOf('isoWeek');
  const lastDayOfPage = lastDayOfMonth.endOf('isoWeek');
  const formattedDays = [];

  while (currentDayOfPage.isSameOrBefore(lastDayOfPage)) {
    const dayFormatted = currentDayOfPage.format('YYYY-MM-DD');
    if (currentDayOfPage.isBefore(firstDayOfMonth) || currentDayOfPage.isAfter(lastDayOfMonth)) {
      formattedDays.push({
        hidden: true,
        date: dayFormatted,
      });
    } else {
      formattedDays.push({
        labelDay: currentDayOfPage.format('D'),
        disabled: datesAsString.indexOf(dayFormatted) < 0,
        date: dayFormatted,
      });
    }
    currentDayOfPage = currentDayOfPage.add(1, 'day');
  }
  return formattedDays;
};
